import { createSlice, PayloadAction } from '@reduxjs/toolkit';

/**
 * HomieLiteRent
 */
type HomieLiteRentsAction = PayloadAction<{
  homieLiteRents?: any,
  metaRents?: any,
  errorMessage?: string
}>;

export type HomieLiteRents = {
  homieLiteRents: any,
  loading: boolean,
  errorMessage: string,
  meta: any[],
  homieLiteRentsFetched: boolean,
  homieLiteRentsLoadingList: any[],
  homieLiteRentsUpdatedList: any,
  lastHomieLiteRentUpdated: any
};

const homieLiteRentsInitialState: HomieLiteRents = {
  homieLiteRents: [],
  meta: {},
  loading: false,
  errorMessage: '',
  homieLiteRentsFetched: false,
  homieLiteRentsLoadingList: [],
  homieLiteRentsUpdatedList: {},
  lastHomieLiteRentUpdated: null
};

const homieLiteRentSlice = createSlice({
  name: 'HomieLiteRent',
  initialState: homieLiteRentsInitialState,
  reducers: {
    fetchHomieLiteRents(state: HomieLiteRents) {
      state.loading = true;
    },
    homieLiteRentsFetched(
      state: HomieLiteRents,
      { payload }: HomieLiteRentsAction
    ) {
      const { homieLiteRents, meta, errorMessage } = payload;

      state.homieLiteRents = homieLiteRents || [];
      state.meta = meta || [];
      state.errorMessage = errorMessage || '';
      state.loading = false;
      state.homieLiteRentsFetched = true;
      state.homieLiteRentsLoadingList = [];
      state.homieLiteRentsUpdatedList = {};
    },
    startHomieLiteRent(state: any, action: any) {
      state.homieLiteRentsLoadingList.push(action.payload.id);
    },
    homieLiteRentUpdated(state: any, action: any) {
      const rent = {
        id: action.payload.id,
        status: action.payload.status,
        errorMessage: action.payload.errorMessage || ''
      };

      state.homieLiteRentsUpdatedList[action.payload.id] = rent;
      state.lastHomieLiteRentUpdated = rent;

      if (!action.payload.errorMessage) {
        const index = state.homieLiteRents.findIndex(
          rent => rent.id === action.payload.id
        );

        state.homieLiteRents[index].status = 'started';
      }

      const loadingIndex = state.homieLiteRentsLoadingList.indexOf(
        action.payload.id
      );

      if (loadingIndex > -1) {
        state.homieLiteRentsLoadingList.splice(loadingIndex, 1);
      }
    }
  }
});

export const HomieLiteRentActions = homieLiteRentSlice.actions;
export const HomieLiteRentReducer = homieLiteRentSlice.reducer;
